import React from 'react';
import styled from 'styled-components';
import { Tab, TabProps, Tabs } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { colors } from 'spw-theme';
import { SPWDot } from '.';

const useStyles = makeStyles({
  tabWithDot: {
    '&&': {
      color: colors.fontColor,
      fontSize: '16px',
      lineHeight: '22px',
      opacity: 1,
      padding: '0 24px',
      textTransform: 'uppercase !important',

      '&.Mui-selected': {
        color: colors.dark,
      },
    },
  },
});

export const SPWTab = styled(Tab)`
  &.MuiTab-root {
    flex-direction: row-reverse;

    & > *:first-child {
      margin: 0 0 0 8px;
    }
  }
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    text-transform: capitalize !important;
    min-width: 100px;
    padding: 0px 12px;
    color: ${colors.fontColor};
    &.Mui-selected {
      font-weight: bold !important;
      color: #000000;
    }

    &.MuiTab-labelIcon {
      min-height: unset;
    }
  }
`;
export const SPWTabHeader = styled(SPWTab)`
  && {
    font-size: 18px;
  }
`;

export const SPWTabWithDot = ({
  className,
  length,
  label,
  ...props
}: TabProps & { length?: number }) => {
  const classes = useStyles();

  return (
    <SPWTab
      {...props}
      className={`${className ?? ''} ${classes.tabWithDot}`}
      label={<div>{`${label}${length === 0 ? ' (0)' : ''}`}</div>}
      icon={
        length !== undefined && length !== 0 ? (
          <SPWDot>{length}</SPWDot>
        ) : undefined
      }
    />
  );
};

export const SPWTabs = styled(Tabs)``;

export const SPWTabsDivider = styled.div`
  height: 1px;
  margin-top: -1px;
  background-color: ${colors.grayDivider};
`;

export const SPWTabsHeader = styled(SPWTabs)`
  && {
    border-bottom: 1px solid ${colors.grayDivider};
  }
`;
